export default __webpack_public_path__ + "static/media/Ljungby_logo.f90182df.png";